module.exports = __webpack_public_path__ + "img/banner-web-1.31b9c693.png";